import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Switch, Route } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import LmsImportErrorList from "./LmsImportErrorList";
import LmsImportErrorDetail from "./LmsImportErrorDetail";
import SEO from "../../../UI/SEO/SEO";
export const getLmsImportErrorBasePath = () => getAdminBasePath() + "/lmsImportError";
export const getLmsImportErrorBaseRoute = () => getAdminBaseRoute() + "/lmsImportError";
export const getLmsImportErrorIndexRoute = () => getLmsImportErrorBaseRoute();
export const getLmsImportErrorIndexPath = () => getLmsImportErrorBasePath();
export const getLmsImportErrorDetailPath = (id) => getLmsImportErrorBasePath() + `/${id}`;
export const getLmsImportErrorDetailRoute = () => getLmsImportErrorBaseRoute() + "/:id";
const LmsImportErrorRoutes = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Enrollment Import Errors" }), _jsxs(Switch, { children: [_jsx(Route, { component: LmsImportErrorDetail, path: getLmsImportErrorDetailRoute() }), _jsx(Route, { component: LmsImportErrorList, path: getLmsImportErrorIndexRoute() })] })] }));
};
export default LmsImportErrorRoutes;
